export default [
  {
    position: "absolute",
    top: 26.5,
    left: 16.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 13,
    tooltipText: "analyticsP2.ttTextFive",
    hover: false,
    id: "SP_Analytics_Navigation_HowmanyinTeams",
    index: 0,
  },
  {
    position: "absolute",
    top: 10.2,
    left: 93,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "analyticsP2.mTitleOne",
    mBody: "analyticsP2.mBodyOne",
    id: "SP_Analytics_Info_TeamPay",
    infoIcon: true,
    isAction: false,
    index: 1,
  },
  {
    position: "absolute",
    top: 31.4,
    left: 67,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "analyticsP2.mTitleTwo",
    mBody: "analyticsP2.mBodyTwo",
    id: "SP_Analytics_Info_ContactDetails",
    infoIcon: true,
    isAction: false,
    index: 2,
  },
  {
    position: "absolute",
    top: 0.5,
    left: 0.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 9,
    tooltipText: "analyticsP2.ttTextOne",
    hover: false,
    tooltipClass: "right",
    id: "SP_Analytics_Navigation_Menu",
    index: 3,
  },
  {
    position: "absolute",
    top: 0.5,
    left: 23,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "analyticsP2.ttTextSix",
    hover: false,
    id: "SP_Analytics_Navigation_Communications",
    index: 4,
  },
  {
    position: "absolute",
    top: 2.9,
    left: 98.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "analyticsP2.ttTextFour",
    hover: false,
    id: "SP_Analytics_Navigation_TeamMember",
    index: 5,
  },
];
